import React from 'react';
import { CtaButton } from './CtaButton';
const links = ['Termini di Servizio', 'Privacy Policy', 'Politica di Rimborso', 'Contatti'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-93" data-mp="32nul2myzi10u">
      <div className="mx-auto max-w-5xl text-center" data-id="element-94" data-mp="32p5lcct80qn7">
        <CtaButton label="Scarica STORIA PRONTA™ Ora" data-id="element-95" data-mp="36p6cmy1f4wbo" />

        <p className="mt-10 font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-96" data-mp="36ppk1ktg02bg">
          STORIA PRONTA™
        </p>
        <nav aria-label="Footer" data-id="element-97" data-mp="38quiv78flpl">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-98" data-mp="37o6cv1anxdd">
            {links.map(link => <li key={link} data-id="element-99" data-mp="3qdf5796vj4bp">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-100" data-mp="3qcniknv98gxk">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-101" data-mp="2evxaez79tf1b">
          © 2026 STORIA PRONTA™. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}